<template>
  <div class="margin-neg">
    <b-row v-if="!hasSelects">
      <b-col md="1" sm="2">
        <b-form-group
            id="status"
            label="Status"
            label-for="status-select"
        >
          <b-form-select id="status-select"
                         :plain="true"
                         :options="statusSelects"
                         v-model="statusSelect"
                         size="sm">
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col sm="7" md="7">
        <b-row>
          <b-col sm="4" v-if="selectedDateType === 'D' || selectedDateType === 'W' || selectedDateType === 'G'">
            <b-row>
              <span>Zeitraum</span>
            </b-row>
            <b-row>
              <ch-left
                  @click="move(-1)"
                  style="margin-top: 0.5rem; margin-right: 0.5rem;"
                  title=""
                  v-tooltip="'Zurück'"
                  :class="'icon-1_5x no-select ic-chevron'"  :size="72"></ch-left>

              <datetime
                  style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; margin-top: 0.5rem; width: 60%;"
                  v-model="currentDate"
                  input-class="form-control form-control-sm"
                  input-style="color: black; height: auto; padding-top: 3px; padding-bottom: 3px;"
                  input-id="date"
                  :phrases="datetimeConfig.phrases"
                  :format="{ day: '2-digit', month: '2-digit', year: 'numeric'}"
                  size="sm"
              ></datetime>
              <ch-right
                  @click="move(1)"
                  style="margin-top: 0.5rem; margin-left: 0.5rem;"
                  title=""
                  v-tooltip="'Vor'"
                  :class="'icon-1_5x no-select ic-chevron'" :size="72"></ch-right>

            </b-row>
          </b-col>
          <b-col sm="4" v-else>
            <b-row>
              <span>{{selectedDateType === 'M' ? 'Monat' : 'Jahr'}}</span>
            </b-row>
            <b-row>
              <ch-left
                  @click="move(-1)"
                  style="margin-top: 0.5rem; margin-right: 0.5rem;"
                  title=""
                  v-tooltip="'Zurück'"
                  :class="'icon-1_5x no-select ic-chevron'"  :size="72"></ch-left>

              <month-picker-input
                  key="month-picker"
                  v-if="selectedDateType === 'M'"
                  lang="de"
                  :default-month="defaultMonth"
                  :default-year="defaultYear"
                  input-pre-filled
                  @input="monthPickerChanged"
              ></month-picker-input>
              <month-picker-input
                  key="year-picker"
                  v-if="selectedDateType === 'Y'"
                  lang="de"
                  :default-month="defaultMonth"
                  :default-year="defaultYear"
                  input-pre-filled
                  @change="monthPickerYearChanged"
                  year-only
                  date-format="%Y"
              ></month-picker-input>

              <ch-right
                  @click="move(1)"
                  style="margin-top: 0.5rem; margin-left: 0.5rem;"
                  title=""
                  v-tooltip="'Vor'"
                  :class="'icon-1_5x no-select ic-chevron'" :size="72"></ch-right>

            </b-row>
          </b-col>
          <b-col>
            <b-row>
              <!--b-col md="10"-->
              <b-form-radio-group
                  id="radio-slots"
                  name="radio-options-slots"
                  buttons
                  v-model="selectedDateType"
                  button-variant="secondary"
              >
                <b-form-radio value="D" style="display: flex; flex-direction: column">
                  <!--day-icon class="icon-1_5x ic-chevron" fillColor="#ac121b" :size="72" style="position: inherit;" ></day-icon-->
                  <span class="calendar-item"><b>1</b></span>
                  Tag
                </b-form-radio>
                <b-form-radio value="W" style="display: flex; flex-direction: column">
                  <!--week-icon class="icon-1_5x ic-chevron" fillColor="#ac121b" :size="72" style="position: inherit;" ></week-icon-->
                  <span class="calendar-item"><b>7</b></span>
                  Woche
                </b-form-radio>
                <b-form-radio value="M" style="display: flex; flex-direction: column">
                  <!--month-icon class="icon-1_5x ic-chevron" fillColor="#ac121b" :size="72" style="position: inherit;" ></month-icon-->
                  <span class="calendar-item"><b>31</b></span>
                  Monat
                </b-form-radio>
                <b-form-radio value="Y" style="display: flex; flex-direction: column">
                  <!--year-icon class="icon-1_5x ic-chevron" fillColor="#ac121b" :size="72" style="position: inherit;" ></year-icon-->
                  <span class="calendar-item"><b>{{new Date(Date.parse(this.currentDate)).getFullYear() - 2000}}</b></span>
                  Jahr
                </b-form-radio>
                <b-form-radio value="G" style="display: flex; flex-direction: column">
                  <!--all-icon class="icon-1_5x ic-chevron" fillColor="#ac121b" :size="72" style="position: inherit;" ></all-icon-->
                  <span class="calendar-item"><b>&lt=</b></span>
                  Gesamt
                </b-form-radio>
              </b-form-radio-group>
              <!--/b-col-->
              <!--b-col md="2" -->
              <b-button-group style="margin-left: 8px">
                <b-button style="flex-direction: column;
    display: flex;" @click="$refs.task_filter_modal.showDialog()">
                  <span :class="{'calendar-item': true,  'filter-active': filterActive}"><b>⫧</b></span>
                  Filter
                </b-button>
              </b-button-group>
              <!--/b-col-->
            </b-row>
          </b-col>
        </b-row>
      </b-col>
      <b-col style="padding-bottom: 1rem">
        <b-button style="position:relative; top:0rem; left:12px; float: right"
                  variant="primary"
                  @click="$router.go(-1)"
                  class="px-4 mr-3 mt-auto">Zurück
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {DateTime as LuxonDateTime} from "luxon";
import { MonthPickerInput } from 'vue-month-picker'

import Chevron from 'vue-material-design-icons/ChevronDown.vue';
import DayIcon from 'vue-material-design-icons/AlphaTBoxOutline.vue';
import WeekIcon from 'vue-material-design-icons/AlphaWBoxOutline.vue';
import MonthIcon from 'vue-material-design-icons/AlphaMBoxOutline.vue';
import YearIcon from 'vue-material-design-icons/AlphaJBoxOutline.vue';
import AllIcon from 'vue-material-design-icons/CodeLessThanOrEqual.vue';
import RefreshIcon from 'vue-material-design-icons/Refresh.vue';
import VJstree from 'vue-jstree'
import TaskFilterModal from "@/views/aufgaben_verwaltung/TaskFilterModal.vue";

import ChLeft from 'vue-material-design-icons/ChevronLeft';
import ChRight from 'vue-material-design-icons/ChevronRight';

export default {
  components: {
    TaskFilterModal, Chevron, DayIcon,
    WeekIcon, MonthIcon, YearIcon,
    AllIcon,VJstree, RefreshIcon, MonthPickerInput, ChLeft, ChRight},
  props: {
    onSearch: {
      type: Function,
      default: undefined
    },
    selectedDate: {
      default: () => null
    },
  },
  name: "TourExecutionSearchbar",
  computed: {
    showYear() {
      return true;
    },
    defaultMonth() {
      return LuxonDateTime.fromISO(this.currentDate).month;
    },
    defaultYear() {
      return LuxonDateTime.fromISO(this.currentDate).year;
    }
  },
  data: () => {
    return {
      wasMounted: false,
      datetimeConfig: {phrases: {ok: 'Ok', cancel: 'Abbruch'}, minTime: LuxonDateTime.local().toISO()},
      currentDate: null,
      statusSelect: "A",
      statusSelects: [
        {text: "Alle", value: "A"},
        {text: "Offen", value: "O"},
        {text: "Fertiggestellt", value: "F"},
      ],
      selectedDateType: "Y",
    }
  },
  methods: {
    log() {
      console.log(this.$router);
    },
    monthPickerChanged({monthIndex, year}) {
      let yearDiff = year - this.defaultYear;
      let monthDiff = monthIndex - this.defaultMonth;
      let date = LuxonDateTime.fromISO(this.currentDate);
      date = date.plus({years: yearDiff, months: monthDiff});
      this.currentDate = date.toISO();
    },
    monthPickerYearChanged({monthIndex, year}) {
      let yearDiff = year - this.defaultYear;
      let date = LuxonDateTime.fromISO(this.currentDate);
      date = date.plus({years: yearDiff});
      this.currentDate = date.toISO();
    },
    move(direction) {
      let date = LuxonDateTime.fromISO(this.currentDate);
      if (this.selectedDateType === "D" || this.selectedDateType === "G") {
        date = date.plus({days: direction});
      } else if (this.selectedDateType === "W") {
        date = date.plus({weeks: direction});
      } else if (this.selectedDateType === "M") {
        date = date.plus({months: direction});
      } else if (this.selectedDateType === "Y") {
        date = date.plus({years: direction});
      }
      this.currentDate = date.toISO();
    },
    getCurrentType() {
      return this.statusSelect;
    },
    searchFilter() {
      if (this.onSearch !== undefined) {
        this.onSearch(
            this.statusSelect,
            this.currentDate,
            this.selectedDateType
        )
      }
    },
    onFirstSearch() {
      this.wasMounted = true;
    },
    setQuery({status, date, dateType, module, page}) {
      this.statusSelect = status;
      this.currentDate = date;
      this.selectedDateType = dateType;
    },
  },
  watch: {
    selectedDate: function(newVal, oldVal) {
      if (!this.currentDate) {
        this.currentDate = newVal;
      }
    },
    selectedYear: function(newVal, oldVal) {
      if (this.wasMounted) {
        this.searchFilter();
      }
    },
    selectedNumber: function(newVal, oldVal) {
      if (this.wasMounted) {
        this.searchFilter();
      }
    },
    allYears: function(newVal, oldVal) {
      if (this.wasMounted) {
        this.searchFilter();
      }
    },
    currentDate: function(newVal, oldVal) {
      if (newVal && oldVal && newVal.split("T")[0] === oldVal.split("T")[0]) {
        return
      }
      if (this.wasMounted) {
        this.searchFilter();
      }
    },
    statusSelect: function(newVal, oldVal) {
      if (this.wasMounted) {
        this.searchFilter();
      }
    },
    selectedDateType: function(newVal, oldVal) {
      if (this.wasMounted) {
        this.searchFilter();
      }
    },
  }
}
</script>

<style scoped>

::v-deep .btn.active > .calendar-item {
  color: black;
  border-color: black;
}
.margin-neg {
  background: #fbfbfb;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 1rem;
}
.form-control {
  color: black;
}
.ic-chevron {
  color: #696969;
  vertical-align: middle;
  cursor: pointer;
  margin: 0px;
}
::v-deep .material-design-icon > .material-design-icon__svg {
  bottom: inherit;
}

::v-deep .refresh-icon > .material-design-icon__svg {
  bottom: auto !important;
}

::v-deep .btn.btn-secondary {
  background: white;
  cursor: pointer;
}
.calendar-item {
  height: 1.5rem;
  width: 1.5rem;
  position: inherit;
  vertical-align: middle;
  border: 2px solid #696969;
  border-radius: 0.25rem;
  display: inline-block;
  align-self: center;
  color: #696969;
}

.filter-active {
  background-color: #018a33 !important;
  border-color: #02411b !important;
  color: white !important;
}

::v-deep .tree-icon.none {
  display: none;
}

::v-deep .month-picker-input {
  padding: 0.25rem 0.5rem;
  font-size: 0.765625rem;
  line-height: 1.5;
  border-radius: 0.2rem;
  color: black;
  font-weight: 400;
  border: 1px solid #c0c0c0;
  width: 100%;
  height: 26px;
}

::v-deep .month-picker-input-container {
  height: 26px;
  margin-top: 0.5rem;
  width: 60%;
}

::v-deep .month-picker__container {
  z-index: 100;
}
</style>

<style>
.no-select{
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
.ic-chevron > .material-design-icon__svg {
  position: inherit !important;
}

</style>
